import {
  baseScreen,
} from 'hoc';
import React,
{
  useRef,
} from 'react';
import GeneralTableView from 'src/components/GeneralTableView';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  toJS,
} from 'mobx';
import {
  TableColumnTypes,
} from 'src/components/GeneralTableView/types';
import {
  Assets,
} from 'assets';
import AddIcon from '@material-ui/icons/Add';
import {
  useHistory,
} from 'react-router';
import {
  Speciality,
} from './types';

const specialities: React.FC = () => {
  const {
    backend: {
      specialities: specialitiesStore,
    },
  } = useStores();
  const history = useHistory();
  const ref = useRef<any|null>(null);
  return (
    <div>
      <GeneralTableView<Speciality>
        tableProps={{
          tableRef: ref,
          options: {
            actionsColumnIndex: 10,
            search: false,
            paging: false,
            sorting: false,
          },
          title: i18n.t('SPECIALITIES'),
          actions: [
            // {
            //   icon: () => (
            //     <img
            //       src={Assets.images.common.trash}
            //       alt={i18n.t('DELETE')}
            //     />
            //   ),
            //   onClick: async (event, data) => {
            //     if (!Array.isArray(data)) {
            //       const response = window.confirm(i18n.t('DELETE_SPECIALITY_CONFIRMATION'));
            //       if (response) {
            //         await specialitiesStore.delete(data.id as number);
            //         if (ref && ref.current) {
            //           ref.current.onQueryChange();
            //         }
            //       }
            //     }
            //   },
            // },
            {
              icon: () => (
                <img
                  src={Assets.images.common.edit}
                  alt={i18n.t('EDIT')}
                />
              ),
              onClick: async (event, data) => {
                const type: any = data;
                history.push(`/specialities-form/${type.id}`);
              },
            },
            {
              isFreeAction: true,
              icon: AddIcon,
              onClick: () => {
                history.push('/specialities-form/:id');
              },
              tooltip: i18n.t('ADD_NEW_SPECIALITY'),
            },
          ],
        }}
        options={{
          search: false,
          pageSize: 10,
          filtering: false,
        }}
        get={async (query) => {
          const res = await specialitiesStore.getAll(query);
          const data = toJS(res).map((item) => new Speciality(item));
          return {
            data,
            totalCount: 10,
            page: 1,
          };
        }}
        tableColumns={[
          {
            field: 'id',
            title: i18n.t('ID'),
            type: TableColumnTypes.NUMERIC,
          },
          {
            field: 'englishName',
            title: i18n.t('ENGLISH_TITLE'),
            type: TableColumnTypes.STRING,
          },
          {
            field: 'arabicName',
            title: i18n.t('ARABIC_TITLE'),
            type: TableColumnTypes.STRING,
          },
        ]}
      />
    </div>
  );
};

export const Specialities = baseScreen(specialities, {
  allowedRoles: ['ADMIN', 'NONE'],
});
